<template>
  <div class="mt-6">
    <v-card v-if="!loading && activities.length > 0">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar actividad"
          single-line
          hide-details
        />
      </v-card-title>
      <v-container fluid>
        <v-row class="align-stretch">
          <v-col
            v-for="(activity, i) in filteredActivities"
            :key="i"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="d-flex justify-center card-grid-container"
          >
            <card-component
              :title="`Fecha límite: ${activity.date}`"
              :description="activity.description"
              image="activity"
            >
              <template v-slot:activities>
                <v-btn
                  color="primary"
                  class="responsive-button mb-3"
                  @click="goToText(activity)"
                >
                  Realizar
                </v-btn>
              </template>
              <template v-slot:polls>
                <v-chip color="warning">
                  Tiempo límite: {{ activity.limitTime ? `${activity.limitTime}min` : 'Sin tiempo' }}
                </v-chip>
              </template>
            </card-component>
          </v-col>
        </v-row>
        <v-row v-if="filteredActivities.length === 0" style="height: 40vh" align="center">
          <v-col>
            <p class="text-center">No se encontraron actividades</p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-row v-if="loading" justify="center" align="center" style="height: 80vh">
        <v-col cols="12" class="text-center">
          <v-progress-circular size="80" width="5" color="primary" indeterminate></v-progress-circular>
          <div class="mt-4 text-h6">Cargando...</div>
        </v-col>
      </v-row>

    <v-row v-if="!loading && activities.length === 0" style="height: 60vh" align="center">
      <v-col>
        <v-img
          height="60%"
          width="60%"
          :src="require('@/assets/images/undraw_empty_street_sfxm.svg')"
        />
        <p class="mt-5">Aún no tiene actividades asignadas</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import Swal from "sweetalert2";
import CardComponent from "@/components/UI/CardComponent";
export default {
  props: ['loading'],
  components: {  CardComponent},
  data() {
    return {
      search: '',
    }
  },
  computed: {
    activities() {
      const reply = this.$store.getters['student/getStudentActivitiesReply'];
      const noReply = this.$store.getters['student/getStudentActivitiesNoReply'];
      const now = new Date();
      const mapReply = noReply.filter(activity => {
        if (!activity.pre) {
          const limitDate = new Date(activity.date + 'T23:59:59');
          return limitDate > now; 
        }
        const findPre = reply.find(re => re.id === activity.pre);
        if (findPre) {
          const limitDate = new Date(activity.date + 'T23:59:59');
          return limitDate > now; 
        }
        
      });
      return mapReply;
    },
    filteredActivities() {
      const searchTerm = this.search.toLowerCase();
      return this.activities.filter(activity => {
        const timeText = activity.limitTime ? `${activity.limitTime}min` : 'Sin tiempo';
        const searchString = `
          ${activity.description}
          ${activity.date}
          ${timeText}
        `.toLowerCase();
        return searchString.includes(searchTerm);
      });
    }
  },
  methods: {
    goToText({ id, limitTime }) {
      Swal.fire({
        title:"¿Desea comenzar la actividad?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, comenzar!',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
              const data = {
            limitTime: limitTime * 60,
            timePased: 0
          }
          if (limitTime && !localStorage.getItem('activity_time_' + id)) {
            localStorage.setItem('activity_time_' + id, JSON.stringify(data)); // Cambio en la clave del localStorage
          }
          this.$router.push('/estudiante/textos/' + id);
        }
      });

      
    }
  },

}
</script>